// ActivityTabs.jsx (continued)
import { LuCalendarDays, LuClock, LuDownload } from 'react-icons/lu';
import moment from "moment";
import { CONST } from '../../../../_config';
import { FiUploadCloud } from "react-icons/fi";

export const PDFFilesContent = ({ uploadX }) => {
    console.log("uploadX---->", uploadX);

    const ele = uploadX;
    const url = CONST.IMAGES_URL;

    const downloadPDF = async () => {
        if (ele?.file?.fileName) {
            const fileUrl = url + ele.file.fileName;

            try {
                const response = await fetch(fileUrl);
                const blob = await response.blob();

                const blobUrl = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = blobUrl;
                link.download = ele.file.fileName || "download.pdf";

                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
            } catch (error) {
                console.error("Download failed:", error);
            }
        }
    };

    return (
        <div className="p-6 bg-white space-y-4">
            {ele && ele.createdAt ? (
                <div className="px-6 py-4 rounded-lg border border-gray-300">
                    <div className='flex justify-between items-center'>
                        <div>
                            <h4 className="text-lg lg:text-xl font-medium textblack mb-2">
                                Uploaded Case Study PDF
                            </h4>

                            <div className="flex flex-wrap items-center gap-4 text-gray-600">
                                <div className="flex items-center gap-2.5 text-indigo-600">
                                    <LuCalendarDays size={20} />
                                    <span>
                                        {ele?.createdAt
                                            ? moment(ele.createdAt).format("DD MMM")
                                            : "-"}
                                    </span>
                                </div>

                                <div className="w-px h-5 bg-indigo-600 hidden md:block"></div>

                                <div className="flex items-center gap-2.5 text-indigo-600">
                                    <LuClock size={20} />
                                    <span>
                                        {ele?.createdAt
                                            ? moment(ele.createdAt).format("hh:mm A")
                                            : "-"}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                            <button
                                onClick={downloadPDF}
                                className="w-full sm:w-auto flex items-center font-medium justify-center gap-2 px-3 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50"
                            >
                                <LuDownload size={20} />
                                Download
                            </button>
                        </div>
                    </div>
                </div>
            ) : (

                <div className="flex flex-col items-center justify-center py-20 px-6 rounded-3xl border border-dashed border-gray-300 bg-gradient-to-b from-gray-50 to-white shadow-sm">

                    <div className="flex items-center justify-center w-24 h-24 rounded-full bg-blue-100 text-blue-600 shadow-inner mb-6">
                        <FiUploadCloud size={42} />
                    </div>

                    <h2 className="text-3xl font-semibold text-gray-800 mb-2">
                        No Uploads Found
                    </h2>

                    <p className="text-gray-500 text-center max-w-md leading-relaxed mb-6">
                        User haven't uploaded any files yet.
                    </p>

                </div>
            )}
        </div>
    );
};